<div *ngIf="complianceArea">
  <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;    margin-left: 40px;">Map Control Items</h2>
          <p-table [value]="complianceArea.controlItems"
                       rowGroupMode="subheader"
                       dataKey="category"
                       expandableRowGroups="true"

                       [paginator]="false"
                       [reorderableColumns]="true"
                       (onSort)="updateRowGroupMetaData()"
          >
            <ng-template pTemplate="header">
              <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                <th *ngFor="let col of cols" [pSortableColumn]="col.field" style="text-align: center;width: 20%">
                  Source - {{complianceArea.name}}
                  <!--p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon-->
                </th>
                <th style="text-align: center;width: 10%">{{complianceArea.name}}</th>
                <th *ngFor="let area of complianceAreas" style="text-align: center;width: 10%">{{area.name}}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
              <tr class="ui-widget-header"
                  *ngIf="rowGroupMetadata && rowGroupMetadata[item.category].index === rowIndex">
                <td [attr.colspan]="complianceAreas?.length + 2">
                  <a href="#" [pRowToggler]="item">
                    <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    <span>{{item['category']}}</span>
                  </a>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{item.complianceAreaControlId}}
                  <img [src]="'../../../assets/icon/' + (item.isCloned ? 'broadcast.svg' : 'crossmap.png')" height="20px" *ngIf="item.broadcast"/>
                </td>
                <td style="text-align: center">
                <span *ngFor="let target of ((item.broadcastTargets || {})[complianceArea.complianceAreaId] || [])"
                      pTooltip="{{target.category}}"><span (click)="openControlItem()">{{target.complianceAreaControlId}}</span><span class="pi pi-trash" (click)="deletePair(target)"></span> </span>
                  <span class="pi pi-plus" (click)="addPair(item, complianceArea.complianceAreaId)"></span>
                </td>
                <td style="text-align: center" *ngFor="let area of complianceAreas">
                <span *ngFor="let target of ((item.broadcastTargets || {})[area.complianceAreaId] || [])"
                      pTooltip="{{target.category}}"><span (click)="openControlItem()">{{target.complianceAreaControlId}}</span><span class="pi pi-trash" (click)="deletePair(target)"></span> </span>
                  <span class="pi pi-plus" (click)="addPair(item, area.complianceAreaId)"></span>
                </td>
              </tr>

            </ng-template>

          </p-table>
</div>
